export const LineHeader = ({ title }: { title: string }) => {
	return (
		<div className="flex items-center gap-2 mb-2 px-1">
			<hr className="flex-grow border-t-1 border-gray" />
			<span className="text-accent-foreground text-lg">{title}</span>
			<hr className="flex-grow border-t-1 border-gray" />
		</div>
	);
};
